import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Note, Notes } from "./notes";
import { Book, Books } from "./books";
import { HomeUl, H2, H1, Error, Div } from "./elements";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

const Home = (props) => {
    useEffect(() => {
        document.title = "Duane Hilton";
        window.scrollTo(0, 0);
    }, []);

    return (
        <Div>
            <H1>Duane Hilton</H1>
            <p>Hello!</p>
            <p>
                I'm a software engineer who likes to read. This website contains
                information I've found useful. I hope you find it useful too.
            </p>
            <H2>Notes, ideas, and tips</H2>
            <HomeUl>
                <li>
                    <Link to={"/notes/automating-commit-messages-with-ai"}>
                        Automating commit messages with AI
                    </Link>
                </li>
                <li>
                    <Link to={"/notes/test-driven-development"}>
                        What is TDD?
                    </Link>
                </li>
                <li>
                    <Link to={"/notes/static-websites"}>
                        Static websites with React and AWS
                    </Link>
                </li>
                <li>
                    <Link to={"/notes/"}>More notes</Link>
                </li>
            </HomeUl>
            <H2>Quotes and ideas from my booklist</H2>
            <HomeUl>
                <li>
                    <Link to={"/books/software-design-decoded"}>
                        Software Design Decoded
                    </Link>
                </li>
                <li>
                    <Link to={"/books/iwoz"}>iWoz</Link>
                </li>
                <li>
                    <Link to={"/books/innovators"}>The Innovators</Link>
                </li>
                <li>
                    <Link to={"/books/"}>More books</Link>
                </li>
            </HomeUl>
            <H2>Elsewhere</H2>
            <HomeUl>
                <li>
                    I wrote and maintain{" "}
                    <a href="https://github.com/duane9/nvim-rg">nvim-rg</a>, a
                    plugin that allows you to run ripgrep from Neovim or Vim.
                </li>
                <li>
                    I built PracticeJS (site no longer exists) so I could do
                    coding exercises on a phone. It made the front page of{" "}
                    <a href="https://news.ycombinator.com/item?id=20135047">
                        Hacker News
                    </a>
                    .
                </li>
                <li>
                    I've made a few documentation{" "}
                    <a href="https://github.com/django/django/commits/main?author=duane9">
                        contributions
                    </a>{" "}
                    to Django.
                </li>
                <li>
                    I'm also on <a href="https://github.com/duane9">GitHub</a>{" "}
                    and{" "}
                    <a href="https://www.linkedin.com/in/duanehilton/">
                        LinkedIn
                    </a>
                    .
                </li>
            </HomeUl>
            <H2>Contact</H2>
            <HomeUl>
                <li>You can reach me by emailing duane9 [at] gmail.com.</li>
            </HomeUl>
        </Div>
    );
};

const App = (props) => {
    return (
        <Router>
            <Routes>
                <Route path="/books/:slug" element={<Book />} />
                <Route path="/notes/:slug" element={<Note />} />
                <Route path="/books" element={<Books />} />
                <Route path="/notes" element={<Notes />} />
                <Route path="/error" element={<Error />} />
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Error />} />
            </Routes>
        </Router>
    );
};

const root = createRoot(document.getElementById("app"));
root.render(<App />);
